import React, { useState, useEffect } from 'react';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import Card from '../elementos/basicos/Card';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import Row from 'react-bootstrap/Row';
import Footer from '../elementos/basicos/Footer';
import CargaCards from '../elementos/eventos/CargaCards';
import BuscadorCursos from '../elementos/eventos/BuscadorCursos';
import Paginacion from '../elementos/eventos/Paginacion';
import { AlertBusqueda } from '../elementos/eventos/Alerta';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchCursos } from '../../peticiones_API/Filtros_Consorci_Ocu';



const ConvocatoriaConSub = (categoria) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [ocupadosData, setOcupadosData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estadoBusqueda, setEstadoBusqueda] = useState(false);
  const [escribiendo, setEscribiendo] = useState(false);
  const [alerta, setAlerta] = useState(false);
  const [metadataCurso, setMetadataCurso] = useState(null);
  const [primeraCarga, setPrimeraCarga] = useState(true);

  const currentUrl = decodeURIComponent(window.location.href);
  const urlParts = currentUrl.split('/');
  const URLSubcategoria = urlParts[urlParts.length - 1].split("?")[0];
  let params = new URLSearchParams(location.search);
  const pagina = parseInt(params.get("pagina")) || 1;
  const busqueda = params.get("busqueda") || '';
  const urlPadre = window.location.pathname;
  // console.log("URLSubcategoria", URLSubcategoria);

  useEffect(() => {
    const inicializar = async (categoria) => {
      navigate(`${urlPadre}?pagina=1`);
      gestionPeticionCursoOcupados(1, '');
      setPrimeraCarga(false);
    };
    inicializar();
  }, []);

  useEffect(() => {

    if (!primeraCarga) {

      const actualizarDatos = async () => {

        if (busqueda) {
          navigate(`${urlPadre}?pagina=${pagina}&busqueda=${busqueda}`);
          gestionPeticionCursoOcupados(pagina, busqueda);
        } else {
          navigate(`${urlPadre}?pagina=${pagina}`);
          gestionPeticionCursoOcupados(pagina, '');
        }


      }
      actualizarDatos();
    }

  }, [urlPadre, pagina, busqueda]);

  const textoLink = (text) => {
    return text
      .normalize("NFD") // Descompone caracteres con tildes
      .replace(/[\u0300-\u036f]/g, "") // Quitar acentos
      .replace(/\s+/g, "-") 
      .toLowerCase(); 
  };

  const textoSubtitulo = (text) => {
    if (!text) return "";
    const textoSinGuiones = text.replace(/-/g, " ");
    return textoSinGuiones.charAt(0).toUpperCase() + textoSinGuiones.slice(1).toLowerCase();
  };



  const URLSubcategoriaNormalizada = textoLink(URLSubcategoria);
  const URLSubcategoriaTexto = textoSubtitulo(URLSubcategoria);

  const gestionPeticionCursoOcupados = async (pagina, palabraBuscada) => {
    try {
      const responseData = await fetchCursos(pagina, palabraBuscada, categoria.categoria.urlCat, `/subcategorias/${URLSubcategoriaNormalizada}`);

      setMetadataCurso(responseData.meta);
      setOcupadosData(responseData.data);

      if (responseData.data.length === 0) {
        setAlerta(true);
      } else {
        setAlerta(false);
      }
      setLoading(false);
    } catch (error) {
      console.log("Ha habido un error en ocupados:", error);
    }
  };

  return (
    <>
      <Header />
      <Cabecera
        Titulo={categoria.categoria.categoria.toUpperCase() ? categoria.categoria.categoria.toUpperCase() : "CATEGORÍA DESCONOCIDA"}
        Subtitulo={URLSubcategoriaTexto}
        MargenMenor="true"
      />
      <BuscadorCursos
        placeholder="Introduce curso"
        palabra={busqueda}
        estadoBusqueda={estadoBusqueda}
        setEstadoBusqueda={setEstadoBusqueda}
        escribiendo={escribiendo}
        setEscribiendo={setEscribiendo}
        setAlerta={setAlerta}
      />
      <ContenedorCards>
        <Row className="justify-content-md-center">
          {loading || escribiendo ? (
            <CargaCards alineado={true} />
          ) : alerta ? (
            <AlertBusqueda mensaje="No hay ningún curso que coincida con tu búsqueda " estadoAlerta={alerta} />
          ) : (
            <Card elementosLista={ocupadosData} />
          )}
        </Row>
      </ContenedorCards>

      {metadataCurso !== null || loading === false ? (
        metadataCurso?.totalPages > 1 ? (
          <Paginacion
            currentPage={pagina}
            totalPages={metadataCurso.totalPages || 1}
          />
        ) : null
      ) : null}

      <Footer />
    </>
  );
}

export default ConvocatoriaConSub;
